import { useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';
const STORAGE_KEY = 'wcfantasy.theme';

function read(): Theme {
  try { return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'; }
  catch { return 'dark'; }
}

function apply(t: Theme) {
  try {
    document.documentElement.classList.toggle('light', t === 'light');
    const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    if (meta) meta.content = t === 'light' ? '#f5f6f8' : '#08090c';
  } catch { /* ignore */ }
}

export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(read);
  useEffect(() => { apply(theme); }, [theme]);
  function update(t: Theme) {
    setTheme(t);
    try { localStorage.setItem(STORAGE_KEY, t); } catch { /* ignore */ }
  }
  return [theme, update];
}
